import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import {userInfo} from './api'
import ElementUI from 'element-ui'
import {
  Button, Pagination, Checkbox, Icon, Autocomplete, Loading, Message, Notification, Steps,
  Step, Table, TableColumn, Input, Dialog, Select, Option, Carousel, carouselItem, Upload} from 'element-ui'
import {getStore} from '/utils/storage'
import VueContentPlaceholders from 'vue-content-placeholders'
import PhbMessage from './common/phbMessage'
//import echarts from 'echarts'
import * as echarts from 'echarts'

Vue.use(ElementUI)
Vue.use(VueContentPlaceholders)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Autocomplete)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = PhbMessage
Vue.prototype.$echarts = echarts
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(Carousel)
Vue.use(carouselItem)
Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
})
Vue.config.productionTip = false
const whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/thanks', '/search', '/refreshsearch',
  '/refreshgoods'] // 不需要登陆的页面


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js